import { makeArray } from '../../../../shared/utils';

export interface IShareableStateMigrator {
  migrate(state: any): Promise<void>;
}

export class ShareableStateMigratorService {
  static build(migrators: IShareableStateMigrator[] | IShareableStateMigrator) {
    return new ShareableStateMigratorService(migrators);
  }

  constructor(private migrators: IShareableStateMigrator[] | IShareableStateMigrator) {}

  async migrate(state: any): Promise<void> {
    const promises = makeArray(this.migrators).map((migrator) => migrator.migrate(state));
    await Promise.all(promises);
  }
}
